import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// (Pull-to-refresh mitigation removed per request)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>
);

// ── Service Worker: enables install-as-app + automatic updates ──────────────
// When a new build is deployed, the SW detects the change and fires onUpdate.
// We instruct the waiting SW to activate immediately and then reload the page
// so the user always sees the latest version — even on installed PWAs.
let isReloading = false; // prevent multiple reloads from stacked listeners
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Tell the new service worker to take over immediately
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
    // Reload once the new SW is active (guarded to fire only once)
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (isReloading) return;
      isReloading = true;
      window.location.reload();
    });
    // Also dispatch a custom event so a UI notification can show
    window.dispatchEvent(
      new CustomEvent("sw-update-available", { detail: { registration } }),
    );
  },
  onSuccess: () => {
    console.log("KinShield is now available offline.");
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
